// extracted by mini-css-extract-plugin
module.exports = {"casinoGames":"compact_casinoGames__8vW31","casinoGamesNarrow":"compact_casinoGamesNarrow__A7QfF"};